var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsnapchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.786,
    height: 25.5,
    viewBox: "0 0 27.786 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "snapchat",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M20.786,14.8l2.5-1.954a1.143,1.143,0,0,0,.377-1.257h0a1.143,1.143,0,0,0-1.291-.766l-1.76.389a.571.571,0,0,1-.663-.674c.869-5.349-1.92-9.04-6.309-9.04S6.454,5.191,7.334,10.494a.571.571,0,0,1-.663.72l-1.76-.377a1.143,1.143,0,0,0-1.3.754h0a1.143,1.143,0,0,0,.377,1.257L6.5,14.8a.571.571,0,0,1,.171.686A9.051,9.051,0,0,1,.5,20.357c.149,1.931,3.429.434,4,1.143a3.086,3.086,0,0,1,.571,1.714H7.357c1.714,0,3.783,2.286,6.286,2.286s4.571-2.286,6.286-2.286h2.286a3.086,3.086,0,0,1,.571-1.714c.571-.709,3.863.789,4-1.143A9.051,9.051,0,0,1,20.6,15.488a.571.571,0,0,1,.183-.686Z",
    transform: "translate(-0.5 -1.5)",
    fill: "none",
    stroke: "#b07f4a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsnapchat);
export default __webpack_public_path__ + "static/media/csnapchat.333508b138da822d27959a2e106986c1.svg";
export { ForwardRef as ReactComponent };